<template>
  <VisaForm country="new_zealand" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products="products" />
      <ClientFields v-model="form.client" />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <EntryFields v-model="form.entry" :date-hint="$tt('estimate_entry_in_half_year')" />
      <PassportDetailsNotes half-year-valid />
      <ApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
          <AppRow>
            <IdNumberField v-model="applicant.idNumber" />
            <CityOfBirth v-model="applicant.cityOfBirth" />
          </AppRow>
        </template>
      </ApplicantInfo>
    </template>

    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>